<template>
    <div class="home-news">
        <div class="news-title">新闻资讯</div>
        <div class="news-more" @click="moreNews">查看更多 <i class="el-icon-arrow-right"></i></div>
        <div class="news-content">
            <div class="news-item" v-for="item in newsList.slice(0, 6)" :key="item.title" @click="detailNews(item.id)">
                <div class="title text-overflow-ellipsis">{{ item.title }}</div>
                <div class="content text-overflow-ellipsis">{{ item.introduction }}</div>
                <div class="time">{{ item.createTime }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { getHomeInformationList } from '@/api/index.js'
export default {
    data() {
        return {
            newsList: []
        }
    },
    created() {
        this.getHomeInformationList()
    },
    methods: {
        async getHomeInformationList() {
            let params = {
                current: 1,
                isTop: 0,
                pageSize: 6,
                type: null
            }
            let { code, data, msg } = await getHomeInformationList(params)
            if (code === 0) {
                this.newsList = data.list
            } else {
                console.log(msg)
            }
        },
        moreNews() {
            this.$router.push('/aboutNews')
        },

        detailNews(id) {
            this.$router.push('/aboutNewsdetail?id=' + id)
        }
    },
}
</script>
<style lang="less" scope>
.home-news {
    width: 100%;
    padding-top: 63px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #FFFFFF;

    .news-title {
        font-family: MicrosoftYaHei;
        font-size: 32px;
        color: #000000;
        letter-spacing: 0;
        text-align: center;
        line-height: 60px;
        font-weight: 400;
        margin-bottom: 7px;
    }

    .news-more {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #005FE1;
        text-align: center;
        font-weight: 400;
        margin-bottom: 48px;
        cursor: pointer;

        .el-icon-arrow-right {
            font-weight: bold;
        }
    }

    .news-content {
        width: 1280px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .news-item {
            width: 624px;
            height: 124px;
            padding: 25px;
            background: #FFFFFF;
            border: 1px solid rgba(230, 232, 236, 1);
            margin-bottom: 20px;
            cursor: pointer;

            .title {
                font-family: MicrosoftYaHei-Bold;
                font-size: 18px;
                color: #000000;
                letter-spacing: 0;
                line-height: 24px;
                font-weight: 700;
                margin-bottom: 9px;
            }

            .content {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #555555;
                letter-spacing: 0;
                line-height: 24px;
                font-weight: 400;
                margin-bottom: 5px;
            }

            .time {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #CCCCCC;
                letter-spacing: 0;
                line-height: 24px;
                font-weight: 400;
            }
        }
    }
}
</style>